
import FormControl from "../../MUI_components/FormControl/fomikFormControl";
import { Form, Formik, FieldArray, Field } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openSnackbar } from "../../../Redux/Actions/snackbarActions";
import { Button, Paper } from "@mui/material";
import Title from "../../Card/title";

import ClosingBalanceService from "Service/Accounts/ClosingBalance.service";
import ClosingBalanceSummery from "./ClosingBalanceSummery";
import PreviewTable from "./PreviewTable";

export default function GeneralLedger() {


    const today = new Date().toISOString().split("T")[0];
    const [task, setTask] = useState("generate");
    const [showPreviewTable, setShowPreviewTable] = useState(false);

    const [status, setStatus] = useState({
        closingBalanceAvailable: false
    });
    const componentRef = React.useRef();
    const dispatch = useDispatch();

    const [checked, setChecked] = useState(false)
    const tableRef = useRef(null);
    const [generated, setGenerated] = useState()


    // const [isLoaded, setIsLoaded] = useState(false);
    const [loading, setLoading] = React.useState(false);
    const [initLoad, setInitLoad] = React.useState(false);
    const [closingBalance, setClosingBalnce] = useState([]);
    const [reversable, setReversable] = useState(null)
    const [lastDate, setLastDate] = useState([])

    const [value, setvalue] = useState([]);


    const handleSubmit = async (values, onSubmitProps) => {
        try {
            if (task === "checkStatus") {
                checkLedgerStatus(values);
            }
            else if (task === "preview") {
                let val = {
                    ...values,
                    task: task
                }
                previewClosingBalance(val);
            }
            else if (task === "reverce") {
                let val = {
                    ...values,
                    task: task
                }
                reverseLedger(val);
            }
            else {
                let val = {
                    ...values,
                    task: task
                }
                previewClosingBalance(val);
                dispatch(
                    openSnackbar(true, "success", `General Ledger created Successfully`));
            }
            recentGenerate();
        } catch (e) {
            dispatch(openSnackbar(true, "error", e));
        }
    };
    function formatDate(date, offset) {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + offset);
        return newDate.toISOString().split("T")[0];
    }
    const checkLedgerStatus = async (values) => {
        setLoading(true);
        setInitLoad(true);
        try {
            const res = await ClosingBalanceService.getClosingBalanceByDate(values);
            setClosingBalnce(res.closingBalance);
            setReversable(res.closingBalanceReversable);
            setGenerated(res.closingBalanceGenerate)
            //console.log(res);
            if (res.length === 0) {
                setStatus({
                    ...status,
                    closingBalanceAvailable: false
                });
                setInitLoad(false);
            }
            else {
                setStatus({
                    ...status,
                    closingBalanceAvailable: true
                });
                setInitLoad(false)
            }
        } catch (e) {
            setInitLoad(true);
            dispatch(openSnackbar(true, "error", e));
        }
        setLoading(false);
    };

    const previewClosingBalance = async (values) => {
        try {
            const res = await ClosingBalanceService.previewClosingBalance(values);
            setInitLoad(true);
            setvalue(res)
        } catch (e) {
            dispatch(openSnackbar(true, "error", e));
        }
    };

    const reverseLedger = async (values) => {
        try {

            const res = await ClosingBalanceService.reversal(values);
            dispatch(
                openSnackbar(true, "success", `Reversed successfully`)
            );
            setInitLoad(true);

        } catch (e) {
            dispatch(openSnackbar(true, "error", e));
        }
    };

    const recentGenerate = async (code) => {
        try {
            let response = await ClosingBalanceService.getLastDate(code);
            setLastDate(response)
            //setLastThreeInvoice(response);
        } catch (e) {
            dispatch(openSnackbar(true, "error", e));
        }
    };

    const lastGenDate = lastDate?.map((row)=>(row.ledgerDate))

    const daysDifference = lastGenDate[0]
    ? Math.floor(
        (new Date(today) - new Date(lastGenDate[0])) / (1000 * 60 * 60 * 24)
      ) + 1
    : null;
  


    return (
        <>
            <Title>Generate General Ledger</Title>
            <Paper style={{ paddingBottom: 10 }}>
                <Formik initialValues={{
                    date: today,
                    ledgerType: null
                }}
                    onSubmit={handleSubmit}

                >
                    {(props) => {
                        const {values} = props;
                        return (
                            <Form>
                                <div className="row" style={{ padding: "10px 0" }} >
                                    <div className=" col-3">
                                        <FormControl
                                            control="input"
                                            type="date"
                                            name="date"
                                            size="small"
                                            label="Date"
                                            inputProps={{
                                                max: today,
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>

                                    <div className="col-2">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            onClick={() => {
                                                setTask("checkStatus")
                                                setChecked(true)
                                            }}
                                        >
                                            Check Status
                                        </Button>
                                    </div>
                                    <div className="col-3">
                                        <Button
                                            variant="contained"
                                            color="error"
                                            type="submit"
                                            disabled={
                                                generated === true || 
                                                checked === false ||
                                                !lastGenDate[0] ||  // Ensure lastGenDate[0] is not null
                                                values.date !== formatDate(new Date(lastGenDate[0]), 1)  // Compare the dates
                                            }
                                            onClick={() => {
                                                setTask("generate")
                                            }}
                                        >
                                            Generate and Day Close
                                        </Button>
                                    </div>
                                    <div className="col-2">
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            type="submit"
                                            disabled={reversable === false || checked === false}
                                            onClick={() => {
                                                setTask("reverce")
                                            }}
                                        >
                                            Reverse
                                        </Button>
                                    </div>
                                </div>

                                {checked === true && !generated && (
                                    <div className="mb-3 row flex-end" style={{ marginBottom: 10 }}>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            type="submit"
                                            onClick={() => {
                                                setTask("preview");
                                                setShowPreviewTable(true); // Show PreviewTable when clicked
                                            }}
                                            disabled={generated === true ||  values.date !== formatDate(new Date(lastGenDate[0]), 1) }
                                        >
                                            Preview
                                        </Button>
                                    </div>
                                )}

                                {/* Conditionally render either PreviewTable or ClosingBalanceSummery */}
                                {showPreviewTable ? (
                                    <PreviewTable
                                        value={value}
                                        componentRef={componentRef}
                                        tableRef={tableRef}
                                    />
                                ) : (
                                    <ClosingBalanceSummery
                                        loading={loading}
                                        initLoad={initLoad}
                                        closingBalance={closingBalance}
                                        status={status}
                                        recentGenerate={recentGenerate}
                                        lastDate={lastDate}
                                    />
                                )}
                            </Form>
                        );
                    }}
                </Formik>

            </Paper>


        </>
    );

}

